import {ApiError, Nullish} from 'shared/web';

const HTTP_FORBIDDEN = 403;

/**
 * Telephony endpoints answer 403 when the tenant licence is off or the role lacks
 * `TELEPHONY_CALL`; for the Call flow that means "telephony is not enabled", not a failure.
 */
export const isForbiddenApiError = (error: ApiError | Nullish) =>
  !!error && 'status' in error && error.status === HTTP_FORBIDDEN;
